var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 54,
    viewBox: "0 0 66 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 53,
    rx: 9.5,
    fill: "#7371FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 23.424V22C40 18.134 36.866 15 33 15C29.134 15 26 18.134 26 22V23.424C24.18 24.2183 23.0026 26.0143 23 28V34C23.0033 36.76 25.2399 38.9967 28 39H38C40.76 38.9967 42.9966 36.76 43 34V28C42.9974 26.0143 41.8199 24.2183 40 23.424ZM34 32C34 32.5523 33.5523 33 33 33C32.4477 33 32 32.5523 32 32V30C32 29.4477 32.4477 29 33 29C33.5523 29 34 29.4477 34 30V32ZM38 23H28V22C28 19.2386 30.2385 17 33 17C35.7614 17 38 19.2386 38 22V23Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 53,
    rx: 9.5,
    stroke: "#7371FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.593f319246628dfb1ebc20f1abcd86dc.svg";
export { ForwardRef as ReactComponent };